import { render, staticRenderFns } from "./verify-email-address.vue?vue&type=template&id=29b89457&"
import script from "./verify-email-address.vue?vue&type=script&lang=js&"
export * from "./verify-email-address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports